import axios from 'axios';
import { CommonRootState } from '../combineReducers';
import { sendError } from '../sendError';
import { ThunkAction } from 'redux-thunk';

const fetchPendingCoursesAndProgramsCountSuccess = (payload: number) =>
  ({
    type: 'FETCH_PENDING_COURSES_AND_PROGRAMS_COUNT_SUCCESS',
    payload
  } as const);

export const fetchPendingCoursesAndProgramsCount = (
  userId: string
): ThunkAction<void, CommonRootState, null, Actions> => async dispatch => {
  try {
    const { data } = await axios.get<number>('/api/v1/LmsTrainings/pending', {
      params:
      {
        userId
      }
    });

    dispatch(fetchPendingCoursesAndProgramsCountSuccess(data));
  } catch (error) {
    sendError(error);
  }
};

export type Actions = ReturnType<typeof fetchPendingCoursesAndProgramsCountSuccess>;
